import { EpimsBaseEntityDto } from './epim-base.dto';
export class StorageLocationDto extends EpimsBaseEntityDto {
  StorageLocationId: string;
  FileLocationId: string;
  CabinetShelfRefId: string;
  RackTrayRefId: string;
  FiscalFileRemarks: string;
  IdentityRefId: string;
  SubscriberId: string;
  SubscriptionUserId: string;
}
